import * as React from "react";
import type { SVGProps } from "react";
const SvgIconGym = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 23 13"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.43.01q-.4.12-.59.5l-.07.14v11.54l.07.15q.15.3.44.43c.12.06.17.07.35.07.25 0 .42-.07.6-.24q.19-.2.24-.5c.01-.08.02-1.2.02-2.48V7.29h9.4v2.33l.03 2.49q.04.29.25.49c.17.17.34.24.6.24.17 0 .22 0 .34-.07q.3-.14.44-.43l.06-.15V.65L17.56.5Q17.4.22 17.1.07C17 .01 16.94 0 16.76 0c-.25 0-.42.07-.6.25q-.2.2-.24.49c-.01.08-.02 1.2-.02 2.48v2.34H6.5l-.01-2.34c0-1.28-.01-2.4-.02-2.48C6.4.34 6.08.03 5.68 0zM2.3 1.6q-.26.03-.46.24t-.25.48l-.02 1.7v1.54H1.2c-.57 0-.77.06-.98.28Q0 6.08 0 6.42q-.01.34.22.58c.21.23.41.29.98.29h.37v1.54c0 .85.01 1.6.02 1.69.07.48.5.79.98.72.27-.03.53-.23.65-.5l.07-.13V2.23l-.06-.11c-.17-.38-.52-.57-.93-.52m17.52 0c-.27.04-.53.23-.65.5l-.07.13v8.38l.07.14c.12.26.38.46.65.5q.44.05.73-.25.2-.2.25-.48c0-.08.02-.84.02-1.7V7.3h.37c.57 0 .77-.06.98-.29q.23-.24.22-.58c0-.24-.06-.4-.22-.58-.21-.22-.41-.28-.98-.28h-.37V3.9c-.02-1.8 0-1.72-.17-1.95-.18-.27-.5-.4-.83-.36"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconGym;
